$(function () {
    "use strict";

    var $wrapper = $('.banner-wrap');
    var $video = $wrapper.find('[data-video]');

    var play = function ($video) {
        $video.addClass('video--playing').find('video').get(0).play();
    };

    var video = '<video autoplay loop muted playsinline>' +
        '<source src="' + $video.attr('data-video') + '" type="' + $video.attr('data-type') + '" />' +
        '</video>';
    $wrapper.addClass('video--loading');
    $video.addClass('loading').html(video);
    $video.find('video').on('canplaythrough', function () {
        $wrapper.removeClass('video--loading').addClass('video--loaded');
        $video.removeClass('loading');
        play($video);
    });
});

$(function () {
    "use strict";

    var $wrapper = $('.try-wrap');
    var $video = $wrapper.find('[data-video]');

    var play = function ($video) {
        $video.addClass('video--playing').find('video').get(0).play();
    };

    var video = '<video autoplay loop muted playsinline>' +
        '<source src="' + $video.attr('data-video') + '" type="' + $video.attr('data-type') + '" />' +
        '</video>';
    $wrapper.addClass('video--loading');
    $video.addClass('loading').html(video);
    $video.find('video').on('canplaythrough', function () {
        $wrapper.removeClass('video--loading').addClass('video--loaded');
        $video.removeClass('loading');
        play($video);
    });
});

$(".banner-wrap").click(function() {
    $('html,body').animate({
            scrollTop: $(".grid-wrap").offset().top},
        'slow');
});

$('.banner-wrap').on('click', function(event) {
    var target = $('.grid-wrap');

    if( target.length ) {
        event.preventDefault();
        $('html, body').stop().animate({
            scrollTop: target.offset().top - 30
        }, 1000);
    }
});

$('.owl-carousel').owlCarousel({
    loop:true,
    autoplay:true,
    dots:false,
    autoplayTimeout:3600,
    autoplayHoverPause:false,
    items:1,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    autoHeight:true,
    margin:0,
    nav:false
});